import * as React from 'react';

import styles from './popup_header.css';
import { CloseIcon } from '../../common/icons';

export interface IPopupHeaderOwnProps {
  title: string;
  onClose(): void;
}

export function PopupHeader(props: IPopupHeaderOwnProps) {
  const { title, onClose } = props;

  return (
    <div className={styles['header']}>
      <div className={styles['panel']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['close']} onClick={onClose}>
          <CloseIcon />
        </div>
      </div>
    </div>
  );
}
